var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"article"},[_vm._v(" 请在门户>会议操作配置>专家任务中配置专家任务或专家简介 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }